import * as React from 'react';
import { SVGProps } from 'react';

const IconArrowRightSizeXs = (props: SVGProps<SVGSVGElement>) => (
  <svg viewBox="0 0 12 12" xmlns="http://www.w3.org/2000/svg" {...props}>
    <path
      d="M8.975 6 5 9.975l-.707-.707L7.56 6 4.293 2.732 5 2.025 8.975 6z"
      fillRule="evenodd"
      clipRule="evenodd"
    />
  </svg>
);

export default IconArrowRightSizeXs;
